import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { persist, createJSONStorage } from 'zustand/middleware';

const initialState = {
  drivers: null,
  reportOfFreightOrder: null,
  callsCount: [],
  reportsPage: 0,
  bidders: {
    filters: {},
    page: 1,
    isLoading: false,
    totalPages: null,
  },
};
export const useDriversList = create(
  persist(
    immer((set, get) => ({
      ...initialState,
      setDrivers: (drivers) =>
        set((state) => {
          state.drivers = drivers;
        }),
      setDriversLoading: (payload) =>
        set((state) => {
          state.driversList.isLoading = payload;
        }),
      changeDriversPage: (page) =>
        set((state) => {
          state.driversList.page = page;
        }),
      setDriversTotalPage: (payload) =>
        set((state) => {
          state.driversList.totalPages = payload;
        }),
      setReportPage: (payload) =>
        set((state) => {
          state.reportsPage = payload;
        }),
      setReportsOfFreightOrder: (payload) =>
        set((state) => {
          state.reportOfFreightOrder = payload;
        }),
      setCallsCount: (payload) =>
        set((state) => {
          state.callsCount = payload;
        }),
    })),
    {
      name: '@footab/admin/driversList',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(([key]) => !['drivers'].includes(key))
        ),
    }
  )
);
